import React from 'react';
import { Grid, Card, Typography, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { ResourceErrors as ResourceErrorsType } from '../../lib/instantPageService';

interface ResourceErrorsProps {
  resource_errors: ResourceErrorsType;
}

const ResourceErrors: React.FC<ResourceErrorsProps> = ({ resource_errors }) => {
  const hasErrors = resource_errors.errors.length > 0;
  const hasWarnings = resource_errors.warnings.length > 0;
  
  if (!hasErrors && !hasWarnings) {
    return (
      <Card variant="outlined" sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom color="success.main">
          Aucune erreur détectée
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Aucune erreur ou avertissement n'a été détecté lors de l'analyse de la page.
        </Typography>
      </Card>
    );
  }
  
  return (
    <Grid container spacing={3}>
      {hasErrors && (
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom color="error">
              Erreurs ({resource_errors.errors.length})
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Ligne</TableCell>
                  <TableCell>Colonne</TableCell>
                  <TableCell>Message</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {resource_errors.errors.slice(0, 5).map((error, index) => (
                  <TableRow key={index}>
                    <TableCell>{error.line}</TableCell>
                    <TableCell>{error.column}</TableCell>
                    <TableCell>{error.message}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {resource_errors.errors.length > 5 && (
              <Typography variant="body2" color="text.secondary" mt={1}>
                ... et {resource_errors.errors.length - 5} autres erreurs
              </Typography>
            )}
          </Card>
        </Grid>
      )}
      
      {hasWarnings && (
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom color="warning.main">
              Avertissements ({resource_errors.warnings.length})
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Ligne</TableCell>
                  <TableCell>Colonne</TableCell>
                  <TableCell>Message</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {resource_errors.warnings.slice(0, 5).map((warning, index) => (
                  <TableRow key={index}>
                    <TableCell>{warning.line}</TableCell>
                    <TableCell>{warning.column}</TableCell>
                    <TableCell>{warning.message}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {resource_errors.warnings.length > 5 && (
              <Typography variant="body2" color="text.secondary" mt={1}>
                ... et {resource_errors.warnings.length - 5} autres avertissements
              </Typography>
            )}
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default ResourceErrors;
